import { render, staticRenderFns } from "./Form7CaseInformation.vue?vue&type=template&id=60f2206a&scoped=true"
import script from "./Form7CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form7CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2206a",
  null
  
)

export default component.exports